/**
 * Extract event ID from slug
 * Supports formats: "123" or "event-name-123"
 */
export const extractEventIdFromSlug = (slug: string): number | null => {
    // Try parsing slug as number directly
    const parsedId = parseInt(slug, 10)
    if (!isNaN(parsedId)) {
        return parsedId
    }

    // Try extracting ID from slug format: "event-name-123"
    const parts = slug.split("-")
    const lastPart = parts[parts.length - 1]
    const idFromSlug = parseInt(lastPart, 10)

    if (!isNaN(idFromSlug)) {
        return idFromSlug
    }

    return null
}


